// extracted by mini-css-extract-plugin
export default {"row":"AuthRow_row__8e1tG"};